// extracted by mini-css-extract-plugin
export default {"textContainer":"GHv6OOABPoVuK95DOAq3"};